module.exports = __webpack_public_path__ + "img/reflexo-03.161d05c0.png";